import { useMemo } from 'react';

import { BusinessUnit } from 'domains/brand.d';
import { getPaymentDetail } from 'services';

import useLazyQuery from './useLazyQuery';
import { usePaymentTitles } from './usePaymentTitles';

import type { PaymentDetail } from 'domains/payment-titles.d';

export const usePaymentDetail = (id?: string) => {
  const { data, isLoading: isLoadingPaymentTitles } = usePaymentTitles();
  const isEudoraVdfPayment = useMemo(
    () =>
      data
        ? data?.pages
            .flatMap((item) => item.data)
            .find((item) => item.paymentTitleId === id)
            ?.brand?.toLocaleLowerCase() === BusinessUnit.EUD
        : false,
    [data, id]
  );

  const { isLoading: isLoadingPaymentDetail, ...rest } = useLazyQuery<PaymentDetail, Error>(
    [id],
    () =>
      getPaymentDetail({
        queryKey: [id, isEudoraVdfPayment],
        meta: undefined,
      }),
    {
      staleTime: 2 * 60 * 1000,
      refetchOnWindowFocus: false,
    }
  );

  return {
    isLoading: isLoadingPaymentDetail || isLoadingPaymentTitles,
    isEudoraVdfPayment,
    ...rest,
  };
};
